import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { StatusCodes } from '../../../shared/enums';
import { LimitationModalData } from '../../../shared/models';
import { LimitationModalComponent } from '../components';
import { Observable, of, throwError } from 'rxjs';
import { take } from 'rxjs/operators';
import { AccountService } from '../../../shared/services/user/account.service';

@Injectable({
  providedIn: 'root',
})
export class LimitationService {
  private readonly accountService = inject(AccountService);

  constructor(public dialog: MatDialog) {}

  private modal: MatDialogRef<LimitationModalComponent>;

  /**
   * Guard for Limited-plan gating: if the current account is Limited, opens the
   * plan modal and returns true so the caller can bail out of the action.
   * Usage: `if (this.limitation.blockIfLimited()) return;`
   */
  blockIfLimited(): boolean {
    const account = this.accountService.currentAccount;
    if (account && this.accountService.getIsAccountLimited(account)) {
      this.onPlanLimit();
      return true;
    }
    return false;
  }

  onRequestLimitCatchError(
    error: HttpErrorResponse,
    toThrowError = false,
    withAction: boolean = false,
    hideCloseButton: boolean = false,
  ): Observable<any> {
    if (error.status === StatusCodes.TOO_MANY_REQUESTS && !this.modal) {
      const modalData: LimitationModalData = { type: 'daily', withAction, hideCloseButton };

      this.launchModal(modalData, !hideCloseButton);
    }

    return toThrowError ? throwError(error) : of(null);
  }

  onPlanLimit(shortenText = false, withoutAnyActions = false): void {
    if (!this.modal) {
      const modalData: LimitationModalData = {
        type: 'plan',
        withAction: false,
        shortenText,
        withoutAnyActions,
      };

      this.launchModal(modalData, true);
    }
  }

  private launchModal(modalData: LimitationModalData, disableClose = false): void {
    this.modal = this.dialog.open(LimitationModalComponent, { data: modalData, disableClose });

    this.modal
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => {
        this.modal = null;
      });
  }
}
